import { useDeleteResidentMutation } from "app/services/api/residentsApi";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export const useHandleDeleteResident = (onSuccess?: () => void) => {
  const { showNewToast, showErrorToast } = useDisplayToast();
  const [triggerDeleteResident, { isLoading: isDeleting }] =
    useDeleteResidentMutation();

  const handleDeleteResident = async ({
    residentId,
  }: {
    residentId: number;
  }) => {
    try {
      await triggerDeleteResident({
        residentId,
      }).unwrap();

      showNewToast({
        title: "Resident deleted!",
        message: "The resident was successfully deleted.",
        type: "success",
      });

      onSuccess?.();
    } catch (error) {
      showErrorToast(error);
    }
  };

  return {
    handleDeleteResident,
    isDeleting,
  };
};
